import { createModel } from '../model/index.js';
import model from '../widget/item.model.js';
const WidgetSearchRequestModel = createModel(model);
export default class WidgetSearchRequest extends WidgetSearchRequestModel {
    constructor(rfkId) {
        super();
        this.setRfkId(rfkId);
    }
    setSearchFilter(value) {
        this.setValue('search.filter', value.toJson());
        return this;
    }
}
